import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, DollarSign } from 'lucide-react';
import { customerApi, money, fmtDate, statusPill, statusLabel } from '../../lib/api';

export default function Portal({ me }) {
  const [data, setData] = useState(null);

  useEffect(() => { customerApi.get('/customer/dashboard').then((r) => setData(r.data)); }, []);
  if (!data) return <div className="py-20 text-center text-sm text-[#6b7280]">Loading...</div>;

  return (
    <div className="fade-in space-y-6" data-testid="customer-portal">
      <div>
        <h1 className="text-3xl sm:text-4xl font-semibold">Hi, {me?.name?.split(' ')[0] || 'there'} 👋</h1>
        <p className="text-sm text-[#6b7280] mt-1">Here's your account at a glance</p>
      </div>

      {/* Balance hero */}
      <div className="card p-6 sm:p-8">
        <div className="text-xs font-semibold text-[#6b7280] uppercase tracking-wider mb-2">Balance Due</div>
        <div className="text-4xl sm:text-6xl font-semibold mono text-[#d92027] mb-2" data-testid="balance-due">{money(data.balance_due)}</div>
        <div className="flex gap-4 text-sm mt-4">
          <div><span className="text-[#6b7280]">Total billed:</span> <span className="mono font-semibold">{money(data.total_billed)}</span></div>
          <div><span className="text-[#6b7280]">Total paid:</span> <span className="mono font-semibold text-green-700">{money(data.total_paid)}</span></div>
        </div>
      </div>

      {/* Recent invoices */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-xl font-semibold">Recent Invoices</h2>
          <Link to="/portal/invoices" className="text-xs font-semibold text-[#d92027] flex items-center gap-1">View all <ArrowRight size={12} /></Link>
        </div>
        {(data.recent_invoices || []).length === 0 ? (
          <div className="card p-10 text-center text-sm text-[#6b7280]">No invoices yet.</div>
        ) : (
          <div className="space-y-2">
            {data.recent_invoices.map((inv) => {
              const balance = inv.total - inv.paid_amount;
              return (
                <Link to={`/portal/invoices/${inv.invoice_id}`} key={inv.invoice_id} className="card p-4 flex items-center justify-between hover:border-[#d92027] transition-colors" data-testid={`invoice-${inv.invoice_id}`}>
                  <div>
                    <div className="flex items-center gap-2">
                      <div className="mono font-semibold">{inv.invoice_number}</div>
                      <span className={statusPill(inv.status)}>{statusLabel(inv.status)}</span>
                    </div>
                    <div className="text-xs text-[#6b7280] mt-0.5">Due {fmtDate(inv.due_date)}</div>
                  </div>
                  <div className="text-right">
                    <div className="mono font-semibold">{money(inv.total)}</div>
                    {balance > 0 && <div className="text-xs mono text-[#d92027]">{money(balance)} due</div>}
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
